import React from 'react';
import { ModuleBridge } from '../components';

export const MigrationPlan = () => {
    return <ModuleBridge moduleId="migration_plan_module" />;
};
